"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalGroupState = /** @class */ (function () {
    function ModalGroupState() {
        this.showModal = true;
    }
    return ModalGroupState;
}());
exports.default = ModalGroupState;
//# sourceMappingURL=ModalGroupState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/ModalGroup/ModalGroupState.js
// module id = 1674
// module chunks = 8